import { all, fork, takeLatest, put, select } from 'redux-saga/effects';
import CategoriesApi from 'libs/api/categories';
import CompaniesApi from 'libs/api/companies';
import * as types from './types';
import UIHelper from '../../services/UIHelper';

const api = new CategoriesApi();
const companyApi = new CompaniesApi();

function* getCategories({ payload }) {
  try {
    const {
      data: { categories },
    } = yield api.list(payload);
    yield put({
      type: types.GET_CATEGORIES_SUCCESS,
      payload: categories,
    });
  } catch (e) {
    yield put({
      type: types.GET_CATEGORIES_FAILURE,
      payload: e?.response,
    });
  }
}

function* getStripe({}) {
  try {
    const currentRestaurant = yield select((s) => s.common.currentRestaurant);
    if (!currentRestaurant) {
      return;
    }
    let response = {};

    if (currentRestaurant.company?.stripe_details_submitted) {
      const { data } = yield companyApi.getStripeLoginLink(currentRestaurant?.company?.id);
      response = data;
    } else {
      const { data } = yield companyApi.getStripeLink(
        currentRestaurant?.company?.id,
      );
      response = data;
    }


    if (response?.url) {
      return window.open(response.url);
    } else {
      UIHelper.showError(response?.error);
    }
  } catch (e) {
    UIHelper.showError();
    console.log('e', e);
  }
}

function* watchCategoriesRequest() {
  yield takeLatest(types.GET_CATEGORIES_REQUEST, getCategories);
}

function* watchGetStripeLink() {
  yield takeLatest(types.GET_STRIPE_LINK_REQUEST, getStripe);
}

export default function* commonSaga() {
  yield all([fork(watchCategoriesRequest), fork(watchGetStripeLink)]);
}
